import { parseVariablesDeskCreate } from "../../utils/parseVariablesCreate";
import { handleDeskFields } from "./handleDeskFields";

export const sanitizeIntent = (intent, variables) => {
    const copy = JSON.parse(JSON.stringify(intent));
  
    copy.parameters.forEach((param) => {
      if (param.zendesk_ticket_field) {
        delete param.zendesk_ticket_field.custom_field_options;
        delete param.zendesk_ticket_field.custom_field_options_actual;
  
        if (!param.zendesk_ticket_field.desk_id || !param.zendesk_ticket_field.id) {
          param.zendesk_ticket_field = {};
        }
      }
    });
  
    if (copy.extensions.variables_desk) {
      copy.extensions.variables_desk = parseVariablesDeskCreate(copy.extensions.variables_desk);
    }
  
    handleDeskFields(copy);
  
    if (copy.conditional_responses.length > 0) {
      copy.conditional_responses.forEach((c) => delete c.param0);
    }
  
    if (copy.extensions.auth) {
      delete copy.extensions.auth.access_key_input;
    }
  
    if (!copy.desks?.name) copy.desks = null;
  
    return copy;
  };
  